import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { DocumentInboxClient } from "@/features/documents/DocumentInboxClient";
import { ScanFilesList } from "@/features/documents/ScanFilesList";
import type { DocumentsView } from "@/features/documents/documents.api";

// Transport → Documenten: the work queue *Scans zonder zending*, and *Ingelezen*, the files the reader of WLX went
// through (docs/partner-portal.md §16). Reading takes documents; linking a scan, putting it aside or putting scans in
// takes dossiers_write.
export const Route = createFileRoute("/_shell/documents")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "documents")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  validateSearch: (search: Record<string, unknown>): { state?: DocumentsView } => ({
    state: (["open", "linked", "discarded", "files"] as const).find((state) => state === search.state),
  }),
  component: DocumentsScreen,
});

function DocumentsScreen() {
  const { state } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { session } = Route.useRouteContext();
  const view = state ?? "open";
  const onView = (next: DocumentsView) => navigate({ search: { state: next === "open" ? undefined : next }, replace: true });
  const canWrite = hasModule(session, "dossiers_write");
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Documents">
      {view === "files" ? (
        <ScanFilesList userId={session.userId} onView={onView} canWrite={canWrite} />
      ) : (
        <DocumentInboxClient userId={session.userId} state={view} onView={onView} canWrite={canWrite} />
      )}
    </div>
  );
}
